import styled from '@emotion/styled'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  min-height: 100vh;

  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const MainColumn = styled.div`
  flex-direction: row;
  flex: 1;
  position: relative;
  min-width: 0;

  @media (max-width: 768px) {
    max-width: 100%;
    overflow-x: hidden;
    padding-top: 0px;
    display: flex;
  }
`

export const RouteContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: auto;
  }
`
